import '../../../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';

import { MUTATION } from '../../../gql-operations';
import { Link } from 'react-router-dom';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@apollo/client';

import AuthLayout from '../AuthLayout';

const VerifyAccountPage = ({ history }) => {
    const {t: lnT} = useTranslation();

    const [sendVerificationEmail, { data, error, loading }] = useMutation(MUTATION.SEND_VERIFICATION_EMAIL, {
        onCompleted: res => {
            // console.log('response is', res);
            if (res.sendVerificationEmail.__typename === 'SendVerificationEmailSuccess') {
                setTimeout(() => {
                    history.push('/login', {
                        verificationResponse: res
                    });
                }, 5000);
                // <Link to={'/login'} params={{forgotResponse}}>Create Account</Link>
            }
        }
    });

    const renderErrorMessage = () => {
        if (data && data.sendVerificationEmail) {
            const typename = data.sendVerificationEmail.__typename;

            if (typename === 'SendVerificationEmailSuccess') {
                return (
                    <div className="auth-alert auth-alert--success">
                        <span className="auth-alert-icon">✓</span>
                        <span className="auth-alert-body">{lnT('auth:emailSentSuccessfullyPleaseCheckYourInbox')}</span>
                    </div>
                );
            }

            const errorMessages = {
                UserNotFound: 'User not found',
                UserAlreadyVerified: 'User already verified',
                InternalServerError: "Server error. We'll be back soon. Sorry :("
            };

            return (
                <div className="auth-alert auth-alert--error">
                    <span className="auth-alert-icon">⚠</span>
                    <span className="auth-alert-body">{errorMessages[typename] || lnT('common:unknownError')}</span>
                </div>
            );
        }
    };

    return (
        <AuthLayout>
            <Formik
                initialValues={{
                    email: ''
                }}
                onSubmit={(values, actions) => {
                    sendVerificationEmail({
                        variables: {
                            data: {
                                email: values.email
                            }
                        }
                    });
                    // no update here necessary, we should just redirect somewhere
                    // no return value?
                    actions.setSubmitting(false);
                }}
                validationSchema={Yup.object().shape({
                    email: Yup.string().email().required(lnT('auth:youNeedToPutAProperEmail'))
                })}
            >
                {({ values, handleSubmit, handleChange, handleBlur, errors, touched }) => (
                    <>
                        <h1 className="auth-title">{lnT('settings:verifyAccount')}</h1>
                        <p className="auth-subtitle">{lnT('auth:enterYourEmailAddressBelowAndWe')}</p>

                        {renderErrorMessage()}

                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="auth-field">
                                <input
                                    name="email"
                                    type="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    placeholder={lnT('common:email')}
                                    autoCorrect="off"
                                />
                                <ErrorMessage
                                    name="email"
                                    render={msg => (
                                        <div id="email" className="error">
                                            {msg}
                                        </div>
                                    )}
                                />
                            </div>

                            <button type="submit" className="auth-submit">{lnT('settings:verifyAccount')}</button>
                        </form>

                        <hr className="auth-divider" />

                        <div className="auth-footer">{lnT('auth:backTo')}<Link to={'/login'}>{lnT('auth:signIn')}</Link>
                        </div>
                    </>
                )}
            </Formik>
        </AuthLayout>
    );
};

export default VerifyAccountPage;
